<template>
  <div class="">
    <ZnBreadcrumb>
      <div slot="rightbutton">
        <el-button
          type="primary"
          @click="addCabVisible = true"
          class="basic-btn"
          size="small"
          >添加柜机</el-button
        >
      </div>
    </ZnBreadcrumb>
    <div class="main-content" v-title data-title="柜机管理_试剂采购库存管理系统">
      <!-- ************************************************************************************** -->
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="searchLine">

              <div class="searchItem">
<!--                <label>关键字</label>-->
                <el-input
                  v-model="searchData.cabName"
                  placeholder="请输入柜机名称"
                  size="small"
                  prefix-icon="el-icon-search"
                  @keyup.enter.native="getCabinetList()"
                />
                <!--   <img
                  class="searchIcon"
                  src="../../assets/images/searchIcon.png"
                  alt=""
                />

                <input
                  type="text"
                  v-model="searchData.cabName"
                  placeholder="请输入柜机编号或名称"
                  @keyup.enter="getCabinetList()"
                /> -->
              </div>

              <!-- 备案号 
             <input
                  type="text"
                  v-model="searchData.cabAddress"
                  placeholder="请输入机柜位置、位置"
                  @keyup.enter="getCabinetList()"
                />
                -->
              <div class="searchItem">
<!--                <label>柜机类型</label>-->
                <el-select
                  size="small"
                  v-model="selectValue"
                  @change="getCabinetList"
                  placeholder="请选择柜机类型"
                >
                  <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <!-- <div class="searchItem"> -->
                <!-- <label>所在位置</label>
                <el-input
                  v-model="searchData.cabAddress"
                  size="small"
                  placeholder="请输入位置"
                  prefix-icon="el-icon-search"
                  @keyup.enter.native="getCabinetList()"
                /> -->
                <!-- 所在位置 -->
                <!--  <label>所在位置</label>
                <img
                  class="searchIcon"
                  src="../../assets/images/searchIcon.png"
                  alt=""
                />

                <input
                  type="text"
                  v-model="searchData.cabAddress"
                  placeholder="请输入位置"
                  @keyup.enter="getCabinetList()"
                /> -->
              <!-- </div> -->
              <el-button
                class="search-btn"
                style="margin-left: 45px"
                @click="getCabinetList()"
              >
                快速查询
              </el-button>
              <div style="width: 100%">
                <span style="float:right;">
                  <el-button
                      style="width: 110px"
                      size="small"
                      type="primary"
                      @click="batchPrintCode"
                  >批量打印柜机码</el-button
                  >
                <el-button
                    style="width: 110px"
                    size="small"
                    type="primary"
                    @click="batchDel"
                >批量删除柜机</el-button
                >
<!--                <el-button-->
<!--                    class="batchBtn"-->
<!--                    size="small"-->
<!--                    @click="handlerBatchStock"-->
<!--                >批量盘点</el-button>-->
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- ************************************************************************************** -->

      <el-row :gutter="0" >
          <el-col :span="15" style="margin: 10px 20px; height: 32px; line-height: 32px;">
<!--            <el-button-->
<!--              size="small"-->
<!--              type="primary"-->
<!--              class="batchBtn"-->
<!--              @click="batchPrintCode"-->
<!--              >批量打印柜机码</el-button-->
<!--            >-->
<!--            <el-button-->
<!--              size="small"-->
<!--              @click="batchDel"-->
<!--              class="batchBtn"-->
<!--              >批量删除柜机</el-button-->
<!--            >-->
<!--            <el-button-->
<!--                class="batchBtn"-->
<!--                size="small"-->
<!--                @click="handleDownloadCabinetTemplate"-->
<!--            >下载柜机模板</el-button>-->
<!--            <el-upload-->
<!--                class=""-->
<!--                action=""-->
<!--                style="display: inline-block; margin: 0 10px"-->
<!--                :multiple="false"-->
<!--                :file-list="fileList"-->
<!--                :show-file-list="false"-->
<!--                :http-request="uploadCabinetFile"-->
<!--                accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">-->
<!--              <el-button-->
<!--                  size="small">柜机批量上传</el-button>-->
<!--            </el-upload>-->
<!--            <el-button-->
<!--                class="batchBtn"-->
<!--                size="small"-->
<!--                @click="handlerBatchStock"-->
<!--            >批量盘点</el-button>-->
          </el-col>
        </el-row>

      <!-- 表格 -->
      <div class="goods-info">
        <el-table
          height="600px"
          ref="multipleTable"
          :data="cabinetList"
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 600,
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/emptyCabinet.png" />
            <p>暂无柜机信息</p>
          </template>
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column type="index" width="170" label="柜机编号"></el-table-column>
<!--          <el-table-column sortable prop="id" label="柜机编号" width="170"/>-->
          <el-table-column sortable prop="cabType2" label="柜机类型" width="200">

          </el-table-column>
          <el-table-column sortable prop="cabName" label="柜机名称">
            <template v-slot="scope">
              {{scope.row.cabName}}
<!--              <span v-if="scope.row.operation" style="color:red;">-->
<!--                &nbsp;&nbsp;(盘点中)-->
<!--              </span>-->
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="cabAddress" label="所在位置">
          </el-table-column> -->

          <el-table-column label="柜机ID（锁ID)">
            <template slot-scope="scope">
              <p>
                {{ scope.row.cabIp ? scope.row.cabIp : "/" }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="柜机行列">
            <template slot-scope="scope">
              <p v-if="scope.row.cabType == 2">
                {{scope.row.numX}}行 x {{scope.row.numY}}列
              </p>
              <p v-else>
                /
              </p>
            </template>
          </el-table-column>
          <el-table-column label="托盘存储">
<!--            <template slot-scope="scope">-->
<!--              <p v-if="scope.row.cabType == 2">-->
<!--                已存 <span v-if="scope.row.reagentNum">{{scope.row.reagentNum}}</span>-->
<!--                <span v-else>0</span>-->
<!--                个试剂-->
<!--              </p>-->
<!--              <p v-else>-->
<!--                /-->
<!--              </p>-->
<!--            </template>-->
            <template slot-scope="scope">
              已存 <span v-if="scope.row.reagentNum">{{scope.row.reagentNum}}</span>
              <span v-else>0</span>
              个试剂
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <img
                @click="editCabinet(scope.row)"
                src="../../assets/private/update.png"
                title="编辑"
                style="height: 25px; width: 25px; float: left"
              />

              <img
                @click="delCab(scope.row.id)"
                src="../../assets/private/del.png"
                title="删除"
                style="height: 25px; width: 25px; float: left"
              />

              <img
                @click="printLocolCode(scope.row)"
                v-if="scope.row.cabType == 2"
                src="../../assets/private/printer.png"
                title="打印托盘码"
                style="height: 25px; width: 25px; float: left"
              />

              <!-- v-if="scope.row.cabType == 2" // 智能柜也需要柜机码 -->
              <img
                @click="printCabCode(scope.row)"
                src="../../assets/private/printer22.png"
                title="打印柜机码"
                style="height: 25px; width: 25px; float: left"
              />

<!--             <span v-if="scope.row.cabType == 2">-->
<!--                <img-->
<!--                    v-if="!scope.row.operation"-->
<!--                    @click="joinCheck(scope.row)"-->
<!--                    src="../../assets/private/checkList.png"-->
<!--                    :title="scope.row.operation==1?'结束盘点':'开启盘点'"-->
<!--                    style="height: 25px; width: 25px; float: left"-->
<!--                />-->
<!--              <button v-else style="color: red;background-color:rgba(0,0,0,0);" @click="joinCheck(scope.row)">结束盘点</button>-->
<!--             </span>-->
            </template>
          </el-table-column>
        </el-table>
           <!-- 全选 -->
      <el-row>
        <el-col :span="24">
          <div style="margin: 10px 0; height: 40px; line-height: 40px">
            <span >
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              />&nbsp;全选
            </span>
            <span class="checkAllSpan">已选：{{multiSelect.length}}</span>
            
          </div>
        </el-col>
        <!-- 分页：萍姐说去掉分页 -->
        <!-- <el-col :span="16">
            <Pagination
              :dataTotal="total"
              :totalpage="totalpage"
              :pagesize="pagesdata.pageSize"
              @changePage="changePage"
            ></Pagination>
          </el-col> -->
      </el-row>
       
      </div>

      <!-- 编辑柜机弹框 -->
      <el-dialog
        title="修改柜机"
        :visible.sync="dialogCabinet"
        class="dialogBox"
        width="458px"
      >
        <ul>
          <li>
            <label>柜子类型<span class="requiedText">*</span></label>
            <el-select
              v-model="cabinetEdit.cabType"
              placeholder="请选择"
              disabled
              class="right"
            >
              <el-option
                v-for="item in cabTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <input type="text"
                  v-model="cabinetEdit.phone"
                  placeholder="请输入详细地址"> -->
          </li>
          <li>
            <label
              >柜机ID
              <!-- <span v-if="cabinetEdit.cabType == 2" class="requiedText">*</span> -->
            </label>
            <input
              v-if="cabinetEdit.cabType == 2"
              type="text"
              class="right"
              v-model="cabinetEdit.cabIp"
              maxlength="20"
              placeholder="如有智能锁，请填入智能锁的ID"
            />
            <input
              v-if="cabinetEdit.cabType != 2"
              type="text"
              class="right"
              v-model="cabinetEdit.cabIp"
              maxlength="20"
              disabled
              readonly
              placeholder="无需填写"
            />
          </li>
          <li v-if="cabinetEdit.cabType == 2">
            <label v-if="cabinetEdit.cabType == 2">
              开锁密码
              <!-- <span class="requiedText">*</span> -->
            </label>
            <input
              v-if="cabinetEdit.cabType == 2"
              type="text"
              class="right"
              v-model="cabinetEdit.kaisuoPwd"
              placeholder="如有智能锁，请填入智能锁开锁密码"
            />
          </li>
          <li>
            <label>柜子名称<span class="requiedText">*</span></label>
            <input
              type="text"
              class="right"
              v-model="cabinetEdit.cabName"
              maxlength="20"
              placeholder="请输入柜子名称"
            />
          </li>
          <!-- 柜机位置不要了 -->
          <!-- <li>
            <label>所在位置<span class="requiedText">*</span></label>
            <input
              type="text"
              class="right"
              v-model="cabinetEdit.cabAddress"
              maxlength="50"
              placeholder="请输入所在位置"
            />
          </li> -->
          <li v-if="cabinetEdit.cabType == 2">
            <label>柜机行数<span class="requiedText">*</span></label>
            <input
              type="number"
              class="right"
              v-model="cabinetEdit.numX"
              min="1"
              @change="checkNumberX"
              placeholder="请输入柜机行数"
            />
          </li>
          <li v-if="cabinetEdit.cabType == 2">
            <label>柜机列数<span class="requiedText">*</span></label>
            <input
              type="number"
              class="right"
              @change="checkNumberY"
              v-model="cabinetEdit.numY"
              placeholder="请输入柜机列数"
            />
          </li>
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCabinet = false">取 消</el-button>
          <el-button type="primary" @click="edit">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 添加柜机弹框 -->
      <el-dialog
        title="添加柜机"
        type="primary"
        :visible.sync="addDialog"
        class="dialogBox"
        width="458px"
      >
        <ul>
          <li>
            <label>柜子类型<span class="requiedText">*</span></label>
            <el-select
              v-model="cabinetAdd.cabType"
              placeholder="请选择"
              class="right"
            >
              <el-option
                v-for="item in cabTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <input type="text"
                  v-model="cabinetEdit.phone"
                  placeholder="请输入详细地址"> -->
          </li>
          <li>
            <label
              >柜机ID
              <!-- <span v-if="cabinetAdd.cabType == 2" class="requiedText">*</span> -->
            </label>
            <input
              v-if="cabinetAdd.cabType == 2"
              type="text"
              class="right"
              v-model="cabinetAdd.cabIp"
              maxlength="20"
              placeholder="如有智能锁，请填入智能锁ID"
            />
            <input
              v-if="cabinetAdd.cabType != 2"
              type="text"
              class="right"
              v-model="cabinetAdd.cabIp"
              maxlength="20"
              disabled
              readonly
              placeholder="无需填写"
            />
          </li>
          <li v-if="cabinetAdd.cabType == 2">
            <label v-if="cabinetAdd.cabType == 2">
              开锁密码
              <!-- <span class="requiedText">*</span> -->
            </label>
            <input
              v-if="cabinetAdd.cabType == 2"
              type="text"
              class="right"
              v-model="cabinetAdd.kaisuoPwd"
              placeholder="如有智能锁，请填入智能锁开锁密码"
            />
          </li>
          <li>
            <label>柜子名称<span class="requiedText">*</span></label>
            <input
              type="text"
              class="right"
              v-model="cabinetAdd.cabName"
              maxlength="20"
              placeholder="请输入柜子名称"
            />
          </li>
         
          <!-- 柜机位置 by 萍姐说不要了，11.1 发版后的第一天 -->
          <!-- <li>
            <label>所在位置<span class="requiedText">*</span></label>
            <input
              type="text"
              class="right"
              v-model="cabinetAdd.cabAddress"
              maxlength="50"
              placeholder="请输入所在位置"
            />
          </li> -->
          <li v-if="cabinetAdd.cabType == 2">
            <!--  <label>柜机行数1<span class="requiedText">*</span></label> -->
            <label>柜机行数<span class="requiedText">*</span></label>
            <input
              type="number"
              class="right"
              v-model="cabinetAdd.numX"
              placeholder="请输入柜机行数"
              @input="
                (e) => (cabinetAdd.numX = e.target.value.replace(/[^\d]/g, ''))
              "
              max="20"
              @blur="onNumblurX"
            />
          </li>
          <li v-if="cabinetAdd.cabType == 2">
            <label>柜机列数<span class="requiedText">*</span></label>
            <input
              type="number"
              class="right"
              v-model="cabinetAdd.numY"
              placeholder="请输入柜机列数"
              @input="
                (e) => (cabinetAdd.numY = e.target.value.replace(/[^\d]/g, ''))
              "
              max="20"
              @blur="onNumblurY"
            />
          </li>
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialog = false">取 消</el-button>
          <el-button type="primary" @click="add">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 打印柜机码弹框 -->
      <el-dialog
        title="生成柜机码"
        :visible.sync="dialogCab"
        class="placeDia"
        width="460px"
        @opened="makeNewCode"
      >
        <div class="addressBox" id="print2">
          <!-- <img :src="curLocationCode" alt=""> -->
          <div ref="qrcode" class="codeBox"></div>
          <div class="info">
            <!-- <div class="infoText">柜机位置：{{ curCabObj.cabAddress }}</div> -->
            <div class="infoText"><span class="printCabTitle">柜机名称：</span><div class="printCabContent">{{ curCabObj.cabName}}</div></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCab = false">取 消</el-button>
          <el-button
            type="primary"
            v-print="'#print2'"
            @click="dialogCab = false"
            >确认生成并打印</el-button
          >
        </div>
      </el-dialog>

      <!-- 批量打印柜机码弹框 -->
      <el-dialog
        title="批量生成柜机码"
        :visible.sync="batchDialogCab"
        class="placeDia"
        width="460px"
        @opened="batchMakeNewCode"
      >
        <div class="allScrollBox">
          <div id="print1">
            <div
              class="addressBox"
              style="margin-bottom: 20px;page-break-after:always"
              v-for="(item, index) in multiSelect"
              :key="index"
            >
              <!-- <img :src="curLocationCode" alt=""> -->
              <div :id="item.id" class="codeBox"></div>
              <div class="info">
                <!-- <div class="infoText">柜机位置：{{ item.cabAddress }}</div> -->
                <div class="infoText"><span class="printCabTitle"><span class="printCabTitle">柜机名称：</span></span><div class="printCabContent">{{ item.cabName }}</div></div>
              </div>
              <br />
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="batchDialogCab = false">取 消</el-button>
          <el-button
            type="primary"
            v-print="'#print1'"
            @click="batchDialogCab = false"
            >确认生成并打印</el-button
          >
        </div>
      </el-dialog>

      <el-dialog title="添加柜机" :visible.sync="addCabVisible" width="30%" :show-close="false">
        <div>
          <el-row>
            <el-col><span><el-radio v-model="cabRadio" label="1">单个添加 (在线逐一编辑柜机信息并添加)</el-radio></span></el-col>
          </el-row>
          <el-row style="padding-top: 25px;">
            <el-col>
              <span><el-radio v-model="cabRadio" label="2">批量添加 (编辑Excel文件,一键导入添加)</el-radio></span>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addCabVisible = false,cabRadio='1'">取 消</el-button>
          <el-button type="primary" @click="cabVisibleSubmit">确 定</el-button>
        </span>
      </el-dialog>

      <div>
        <el-dialog title="批量添加柜机" :visible.sync="addBatchCabVisible" width="40%" class="batchCabClass">
          <div>
            <div>
              <span><i class="el-icon-warning" /> 请先下载 <el-link type="primary" :ununderline="false" @click="handleDownloadCabinetTemplate">柜机模板Excel</el-link></span>
              <span>  按要求编辑完成后在上传，一键完成！</span>
            </div>
            <div>
            <span>
                          <el-upload class="upload-demo"
                              ref="upload"
                              action=""
                              :multiple="true"
                              :file-list="fileList" accept=".xlsx,.xls"
                              :on-change="handleFileChange" :on-remove="handleFileRemove"
                              :auto-upload="false" style="padding-top: 20px">
                          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        </el-upload>
              <el-progress v-show="progress" :percentage="progressLen"/>
          </span>
            </div>

          </div>
          <span slot="footer" class="dialog-footer">
          <el-button @click="addBatchCabVisible = false,fileList=[],progress = false,realFileList=[]">取 消</el-button>
          <el-button type="primary" @click="submitUpload">确认上传</el-button>
        </span>
        </el-dialog>
      </div>

    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2"; //引入生成二维码插件
export default {
  //components: { Pagination },
  data() {
    return {
      routeParams:null,
      realFileList: [],
      fileName: [],
      progress : false,
      progressLen: 0,
      addBatchCabVisible: false,
      cabRadio: '1',
      addCabVisible: false,
      checkBtnContent:"开启盘点",
      checkBtnFlag:false,
      fileList: [],
      isIndeterminate: false,
      checkAll: false,
      multiSelect: [], // 复选框
      allQrList: [],
      searchData: {
        cabAddress: "",
        cabName: "",
        pageNum: 1,
        pageSize: 10,
      },
      //状态下拉选择选项
      selectOptions: [
        {
          value: 1,
          label: "智能柜",
        },
        {
          value: 2,
          label: "门禁柜",
        },

        {
          value: null,
          label: "请选择",
        },
      ],
      selectValue: "",
      cabinetList: [],
      cabinetEdit: {},
      cabinetXY:{},
      dialogCabinet: false,
      addDialog: false,
      printDialog: false,
      batchDialogCab: false,
      cabinetAdd: {
        cabType: 2,
      },
      total: 0,
      totalpage: 0,
      pagesdata: {
        pageNum: 1,
        pageSize: 10,
      },
      cabTypeOptions: [
        {
          value: 1,
          label: "智能柜",
        },
        {
          value: 2,
          label: "门禁柜",
        },
      ],
      curCabObj: {},
      curCabCode: "",
      dialogCab: false,
      canAddFlag: true,
      kaisuoPwd: "",
    };
  },
  created() {
    const data = this.$route.params;
    if(data && data.type == 'orderAdd'){
      this.addCabVisible = true;
      this.routeParams = data.type;
    }
    this.getCabinetList();
  },
  beforeRouteEnter(to, from, next) {
    console.log(to.query.type);
    if (to.query.type == 'add' || to.query.type == 'addC') {
      next(vm=>{console.log(vm);vm.addCabVisible = true;vm.routeParams = to.query.type}); //切记操作完一定要记得放行,否则无法正常跳转页面
    }else{
      next();
    }

  },
  methods: {
    //修改柜机行列时的校验
    checkNumberX(e) {
      console.log(this.cabinetXY.numX)
      if (e.target.value <= this.cabinetXY.numX) {
        this.cabinetEdit.numX = this.cabinetXY.numX
        this.$message.warning("柜机行列不能改小")
      }
    },
    checkNumberY(e) {
      if (e.target.value <= this.cabinetXY.numY) {
        this.$message.warning("柜机行列不能改小！")
        this.cabinetEdit.numY = this.cabinetXY.numY
      }
    },
    handleFileChange(file, fileList){
      this.realFileList = fileList;
    },
    handleFileRemove(file, fileList){
      this.realFileList = fileList;
    },
    async submitUpload() {
      var param = new FormData();
      const files = this.realFileList;
      if(files.length <1){
        return
      }
      files.forEach(file => {
        param.append('file', file.raw);
        this.fileName.push(file.name);
      });
      this.progress = true;
      this.progressLen = Math.ceil(Math.random()*100);
      const res =  await this.$apiFetch.post('/lockerCabinet/importDataMultipart', param)
      var resultCode = res.data.errorCode;
      if('200' == resultCode){
        this.successResult();
      }else{
        this.errorResult(res.data);
      }
    },
    successResult(response, file, fileList){
      this.progressLen = 100;
      this.$alert('文件上传成功', '', {
        confirmButtonText: '确定',
        iconClass: 'el-icon-warning',
        callback: action => {
          this.addBatchCabVisible = false;
          this.addCabVisible = false;
          this.getCabinetList();
          this.cabRadio = '1';
          this.progress = false;
          this.progressLen = 0;
          this.$refs.upload.clearFiles();
          this.realFileList = [];
        }
      });
    },
    errorResult(err, file, fileList){
      var msg = ''
      if(null != err.errorMsg){
        msg = err.errorMsg;
      }
      this.$alert('文件上传失败，'+msg, '请重新选择', {
        confirmButtonText: '确定',
        iconClass: 'el-icon-warning',
        callback: action => {
          this.progress = false;
          this.progressLen = 0;
        }
      });
    },
    cabVisibleSubmit(){
      const radio = this.cabRadio;
      if('1' == radio){
        this.addDialog = true
      }else{
        this.addBatchCabVisible = true;
      }
    },
    // 批量盘点
    handlerBatchStock(){
      let ids = [];
      try{
        this.multiSelect.forEach((item) => {
          if(item.cabType == 1){
            throw new Error("所选柜机中包含智能柜，不允许批量盘点；请确保只有门禁柜");
          }
          ids.push(item.id);
        });
      }catch (e){
        this.$message.warning(e.message)
        return ;
      }

      let operation = 1;
      this.$apiFetch
          .post("/stocktaking/batchJoinCheck", {'cabinetIds':ids,'operation':operation})
          .then((res) => {
            if (!res.data.code) {
              this.$notify({
                title: '盘点已开启',
                message: '请使用PDA进行盘点扫描',
                position: 'bottom-right',
                customClass:'success_notify'
              })
              this.dialogCabinet = false;
              this.cabinetEdit = {};
              this.getCabinetList();
            } else {
              this.$message({
                showClose: true,
                message: res.data.description,
                type: "error",
              });
              // this.getCabinetList();
            }
          });

    },

    //加入盘点
    joinCheck(data){
      let title = data.operation == 1?"确认结束盘点吗？结束后未盘点到的试剂将会变成盘点遗失状态！":"是否确定开启盘点？开启盘点后，中途不能暂停，只能待盘点结束后方能操作柜机中的试剂"
      let operation = data.operation == 1?0:1;
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$apiFetch
                .get("/stocktaking/joinCheck", {cabinetId:data.id,operation:operation})
                .then((res) => {
                  if (!res.data.code) {
                    this.$notify({
                      title: data.operation==1?'盘点已结束':'盘点已开启',
                      message: data.operation==1?'您可以正常操作试剂了':'请使用PDA进行盘点扫描',
                      position: 'bottom-right',
                      customClass:'success_notify'
                    })
                    this.dialogCabinet = false;
                    this.cabinetEdit = {};
                    this.getCabinetList();
                  } else {
                    if(res.data.code == 420){
                      this.$notify({
                        customClass:'error_notify',
                        title: '您没有权限结束盘点',
                        message: res.data.description,
                        position: 'bottom-right',
                      })
                    }else{
                      this.$notify({
                        customClass:'error_notify',
                        title: '失败',
                        message: res.data.description,
                        position: 'bottom-right',
                      })
                    }
                    this.dialogCabinet = false;
                    this.cabinetEdit = {};
                  }
                });
          })
          .catch(() => {

          });

    },

    // 全选
    handleCheckAllChange(val) {
      this.checkAll = val;
      var rows = this.cabinetList;
      var value = val ? rows : [];
      if (val) {
        rows.forEach((row) => {
          console.log(row);
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      console.log(this.multipleSelection);
    },
    //下载模板
    handleDownloadCabinetTemplate(){
      // window.location.href =
      //     "http://admin.lawkeychem.com/files/cupboardTemplate.xlsx";
      const resp = this.$apiFetch
          .download("/lockerCabinet/downTemplate")
          .then((resp) => this.downloadFile(resp,'Lawkey cupboard Template'));
    },
    uploadCabinetFile(e){
      this.isLoading = true;
      let _this = this;
      let f = e.file; // 文件信息
      if (!f) return false;
      else if (!/\.(xls|xlsx)$/.test(f.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      var param = new FormData();
      //将文件append到formData对象
      param.append("file", f);
      this.$apiFetch.post('/lockerCabinet/importData', param).then((res) => {
        this.isLoading = false;
        if (!res.data.code) {
          _this.$message.success("导入成功");
          _this.getCabinetList();
        } else {
          _this.$message.error("导入失败 -- " + res.data.description);
        }
      });
    },
    // 批量 校验
    batchCheck() {
      if (this.multiSelect == null || this.multiSelect.length <= 0) {
        this.$message.error("请先选择");
        return false;
      }
      return true;
    },

    // 批量打印柜机码
    batchPrintCode() {
      if (!this.batchCheck()) return;
      this.batchDialogCab = true;
    },

    // 批量打印柜机码 open
    batchMakeNewCode() {
      let list = this.multiSelect;
      list.forEach((ele, idx) => {
        const curRef = document.getElementById(ele.id);
        // const codeData = { gridId: ele.id };
        const codeData = { cabId: ele.id };
        if (this.allQrList[idx]) {
          this.allQrList[idx].clear();
          this.allQrList[idx].makeCode(JSON.stringify(codeData));
        } else {
          const qr = new QRCode(curRef, {
            text: JSON.stringify(codeData),
            width: 100,
            height: 100,
          });
          this.allQrList[idx] = qr;
        }
      });
    },

    // 批量删除
    batchDel() {
      if (!this.batchCheck()) return;
      let delIds = [];
      this.multiSelect.forEach((item) => {
        delIds.push(item.id);
      });

      this.$confirm(
          "是否确认删除?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        this.$apiFetch
            .get(`lockerCabinet/batchDeleteCabinet?ids=${delIds}`)
            .then((res) => {
              if (!res.data.code) {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.getCabinetList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.description,
                  type: "error",
                });
              }
            });
      });
    },

    // 多选框改变事件
    handleSelectionChange(val) {
      this.multiSelect = val;
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.cabinetList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cabinetList.length;
    },

    //柜机列表
    getCabinetList() {
      //let params = this.pagesdata;
      let params = this.searchData;
      // params.operation = this.selectValue;
      params.cabType = this.selectValue;
      // params.cabAddress = this.cabName;
      params.pageNum = 1;
      params.pageSize = 1000; // 为了查询所有
      this.$apiFetch
        .get("lockerCabinet/queryCabinetList", params)
        .then((res) => {
          this.cabinetList = res.data.list;
          this.cabinetList.forEach((item) => {
            if (item.cabType == 1) {
              item.cabType2 = "智能柜";
            } else if (item.cabType == 2) {
              item.cabType2 = "门禁柜";
            }
          });
          this.total = res.data.total;
          this.totalpage = res.data.pages;
        });
    },
    //打开编辑
    editCabinet(row) {
      console.log(row);
      this.dialogCabinet = true;
      const { cabIp, cabName, cabAddress, cabType, id, numX, numY, kaisuoPwd } =
        row;
      this.cabinetEdit = {
        cabIp,
        cabName,
        cabAddress,
        cabType,
        id,
        numX,
        numY,
        kaisuoPwd,
      };
      this.cabinetXY={
        numX,
        numY,
      }
    },
    //编辑
    edit() {
      // this.dialogCabinet = true
      // const { cabIp, cabName, cabAddress, cabType } = row
      // this.cabinetEdit = {cabIp, cabName, cabAddress, cabType}
      let params = this.cabinetEdit;
      this.$apiFetch
        .post("/lockerCabinet/updateCabinet", params)
        .then((res) => {
          if (!res.data.code) {
            this.$message({
              showClose: true,
              message: "编辑成功",
              type: "success",
            });
            this.dialogCabinet = false;
            this.cabinetEdit = {};
            this.getCabinetList();
          } else {
            this.$message({
              showClose: true,
              message: res.data.description,
              type: "error",
            });
          }
        }).catch(e=>{
          if(e.data.code!=200){
            this.$message.error("修改失败！")
          }
      });
    },
    add() {
      // debugger;
      if (!this.canAddFlag) return;
      this.canAddFlag = false;
      let params = this.cabinetAdd;
      // const ipReg = new RegExp(
      //   "^(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|[1-9])\\." +
      //     "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\." +
      //     "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\." +
      //     "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)$"
      // );
      // debugger;
      this.cabIp = params.cabIp;
      this.cabName = params.cabName;
      this.cabAddress = params.cabAddress;
      this.cabType = params.cabType;
      this.kaisuoPwd = params.kaisuoPwd;

      // const { cabName, cabAddress, cabType, kaisuoPwd } = params;
      const { cabName, cabType, kaisuoPwd } = params; // 地址不要了
      // if (!cabName || !cabAddress || !cabType) {
      if (!cabName || !cabType) {
        if (cabType == 2) {
          if (!this.cabinetAdd.numX || !this.cabinetAdd.numY) {
            this.$message.error("请填写完整后提交");
            this.canAddFlag = true;
            return;
          }
        } else {
          if (!kaisuoPwd) {
            this.$message.error("请填写完整后提交");
            this.canAddFlag = true;
            return;
          }
        }
      }
      // if (!ipReg.test(cabIp) && cabType == 1) {
      //   this.$message.error("柜机ip格式错误");
      //   this.canAddFlag = true
      //   return;
      // }
      this.$apiFetch
        .post("/lockerCabinet/insertCabinet", params)
        .then((res) => {
          if (!res.data.code) {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.addDialog = false;
            this.cabinetAdd = {cabType:2};
            this.getCabinetList();
            this.addCabVisible = false;
            if(this.routeParams == 'add' || this.routeParams == 'addC' || this.routeParams == 'orderAdd'){
              this.showReturnPage()
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.description,
              type: "error",
            });
          }
          this.canAddFlag = true;
        });
    },
    // 显示返回页面
    showReturnPage(){
      let title = "添加成功，是否返回"
      this.$confirm(title, "提示", {
        confirmButtonText: "返回",
        cancelButtonText: "停留此页面",
        type: "warning",
      }).then(()=>{
        // this.router.back()
        if(this.routeParams == 'add'){
          this.$router.push({path:'/addReagent?name=新增试剂&page=return'})
        }else if(this.routeParams == 'orderAdd'){
          this.$router.push({ path: "myPurchase" });
        }else {
          this.$router.back()
        }
      })
    },
    changePage(data) {
      this.pagesdata.pageNum = data;
      this.searchData.pageNum = data;
      this.getCabinetList();
    },
    //打印位置码
    printLocolCode(data) {
      console.log(data);
      localStorage.setItem("currentCabinet", JSON.stringify(data));
      this.$router.push("/print?id=" + data.id);
    },
    onNumblurX(e) {
      if (e.target.value > 20) {
        this.cabinetAdd.numX = 20;
      }
    },
    onNumblurY(e) {
      if (e.target.value > 20) {
        this.cabinetAdd.numY = 20;
      }
    },
    printCabCode(data) {
      this.curCabObj = data;
      this.dialogCab = true;
    },
    makeNewCode() {
      // let codeData = { gridId: this.curCabObj.id };
      let codeData = { cabId: this.curCabObj.id };
      if (this.curCabCode) {
        this.curCabCode.clear();
        this.curCabCode.makeCode(JSON.stringify(codeData));
      } else {
        this.curCabCode = new QRCode(this.$refs.qrcode, {
          text: JSON.stringify(codeData),
          width: 100,
          height: 100,
        });
      }
      console.log(this.curCabCode);
    },
    //删除柜机（门禁柜）
    delCab(id) {
      this.$confirm("确定删除柜机?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$apiFetch
            .get("/lockerCabinet/deleteCabinet", { id })
            .then((res) => {
              if (!res.data.code) {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.getCabinetList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.description,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.bottom_btn{
  float: right;
  
}
.infoText2 {
  font-size: larger;
}
.checkAllSpan {
  margin-left: 10px;
  margin-right: 30px;
  // padding-left: 10px;
  color: #606266;
  font-size: 14px;
}
// .batchBtn {
  // text-align: center;
  // background-color: #ed7d31;
  // width: 110px;
  // height: 40px;
  // margin-right: 20px;
// }

.basic-btn {
  text-align: center;
  width: 103.99px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}
.allScrollBox {
  height: 300px;
  overflow-y: scroll;
}
.main {
  background-color: #ffffff;
}
.goods-info {
  padding: 0 20px;
  // margin-top: 20px;
  background-color: #ffffff;

  .el-table .cell {
    img {
      display: block;
      width: 80px;
    }
    .unBind {
      color: #fa8c16;
    }
  }
  /deep/ .el-input-number--small {
    width: 110px;
  }
  /deep/ .el-input-number__decrease {
    background-color: #ffffff;
  }
  /deep/ .el-input-number__increase {
    background-color: #ffffff;
  }
  .bind-goods {
    //width: 50%;
    text-align: left;
  }
  .del-goods {
    color: #ff4d4f;
  }
}
/deep/ .el-table__empty-block {
  padding: 38px 0 27px 0;
  img {
    display: block;
    width: 196px;
    margin: 0 auto;
  }
  p {
    color: #b1c4e2;
    padding-top: 16px;
  }
}

/deep/ .el-dialog__body ul {
  display: flex;
  flex-direction: column;

  li {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    height: 30px;
    font-size: 14px;
    color: #666666;
    line-height: 20px;

    &:first-child {
      margin-top: 25px;
    }

    .right {
      width: 304px;
      font-size: 14px;
      line-height: 20px;
      border-bottom: 1px solid #cccccc;

      input {
        height: 20px;
        background-color: #fff;
        border: none;
        padding: 0;
      }

      .el-input__icon {
        line-height: 20px;
      }

      &::placeholder {
        color: #ccc;
      }
    }
  }
}

.addressBox {
  display: flex;
  justify-content: center;
  // margin-top: 20px;

  img {
    width: 100px;
    height: 100px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 8px;

    .infoText {
      margin-top: 10px;
      color: #000;
      font-weight: 400;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}
.requiedText {
  color: red;
}
</style>

<style lang="less" scoped>
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      align-items: center;
      // float: left;
      // width: 80%;
      // position: relative;
      // img {
      //   width: 14px;
      //   display: block;
      //   position: absolute;
      //   top: 11px;
      //   left: 9px;
      // }
      input {
        width: 300px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }
      button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      }
      .batch{
        width: 198px;
        height: 136px;
      }
    }
    li.last {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      button {
        min-width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 4px;
        font-size: 13px;
      }
      .download {
        min-width: 110px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 4px;
        font-size: 13px;
        border: 1px solid #478aff;
        color: #478aff;
        background-color: #ffffff;
      }
      button.leading {
        background: #478aff;
        color: #ffffff;
      }

      .el-button {
        padding: 0;
      }
    }
  }
}
.placeDia {
  ul {
    margin-bottom: 20px;
    li {
      padding-top: 20px;
      label {
        display: block;
        color: #666666;
        font-size: 14px;
      }
      input {
        border-bottom: 1px solid #cccccc;
        font-size: 14px;
        line-height: 40px;
        width: 100%;
        color: #333333;
      }
    }
    li:first-child {
      padding-top: 0;
    }
  }
  .locking {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #478aff;
    border-radius: 4px;
    border: 1px solid #478aff;
    background-color: #ffffff;
    margin-top: 25px;
  }
  span.tips {
    color: #ff4d4f;
    padding-top: 6px;
    text-align: center;
    display: block;
  }
}
.searchName {
  input {
    width: 434px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    padding-left: 9px;
  }
  button {
    width: 98px;
    height: 36px;
    margin-left: 12px;
    vertical-align: bottom;
  }
}
.bindDia {
  p {
    padding-top: 25px;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      background-color: #fafafa;
      border-radius: 4px;
      height: 48px;
      margin-top: 8px;
      padding: 0 12px;

      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #333333;
        font-size: 14px;
      }
      /deep/ .el-radio {
        margin-right: 8px;
      }
      /deep/ .el-radio__label {
        color: #333333;
        font-size: 14px;
      }

      .centerbox {
        width: 300px;
        display: flex;
        align-items: center;
      }

      .cabinet-type {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: #eaf1fc;
        border-radius: 4px;
        color: #478aff;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }
      .cabinet-type2 {
        display: block;
        width: 48px;
        height: 20px;
        line-height: 20px;
        background: rgba(250, 140, 22, 0.08);
        border-radius: 4px;
        color: #fa8c16;
        font-size: 12px;
        text-align: center;
        margin-right: auto;
      }
      .remnant {
        padding-right: 10px;
        i {
          color: #081020;
        }
      }

      .chooseText {
        margin-left: 5px;
        font-size: 14px;
        color: #478aff;
        line-height: 20px;
        cursor: pointer;
      }

      /deep/.el-input-number__decrease {
        border-right: 1px solid #e9e9e9;
        background-color: #fafafa;
        .el-icon-minus {
          color: #979797;
          font-weight: 700;
        }
      }
      /deep/ .el-input-number__increase {
        border-left: 1px solid #e9e9e9;
        background-color: #fafafa;
      }
      /deep/.el-input__inner {
        border: 1px solid #e9e9e9;
        color: #333333;
        font-weight: 700;
      }
    }
  }
}
.createDia {
  .code {
    // width: 410px;
    // height: 195px;
    background: #f2f5fa;
    border-radius: 4px;
    padding: 15px;
    display: flex;
    // align-items: center;
  }
  .codeInfo {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 25px;
    color: #333333;
    justify-content: space-between;
  }
  .codeAddress {
    font-size: 14px;
    color: #333333;
    line-height: 25px;
  }
  // .codeImg {
  //   width: 100%;
  //   height: 115px;
  // }
  .info {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .infoText {
      margin-top: 10px;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
}
.supTable {
  img {
    width: 100px;
    height: 100px;
  }
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}

.addressBox {
  display: flex;
  // margin-top: 20px;

  img {
    width: 100px;
    height: 100px;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .infoText {
      margin-top: 10px;
      color: #000;
      font-size: larger;
      font-weight: 600;
      &:first-of-type {
        margin: 0;
      }
    }
  }
}
/deep/.searchLine {
  display: flex;
  align-items: center;
  position: relative;

  .searchItem {
    margin-left: 30px;
    color: var(--zng-normal-color);
    label {
      margin-right: 10px;
    }
  }

  .searchIcon {
    width: 16px;
    height: 16px;
  }

  .el-input {
    width: 200px;
  }

  .el-input__inner {
    height: 36px;
  }

  button {
    margin-left: 12px;
    width: 98px;
    height: 36px;
    line-height: 1;
    text-align: center;
    background: #478aff;
    border-radius: 4px;
    font-size: 13px;
    color: #ffffff;
  }

  .el-select {
    // margin-left: 40px;

    .el-input {
      width: 140px;
    }
  }

  .settingBox {
    margin-left: 56px;
    //display: inline-flexbox;

    .oneLine {
      display: flex;
      align-items: center;

      .beforeText {
        font-size: 13px;
        color: #333333;
        height: 24px;
        line-height: 24px;
      }

      img {
        display: inline-block;
        margin-left: 12px;
        width: 40px;
        height: 24px;
        cursor: pointer;
      }

      .afterText {
        margin-left: 9px;
        font-size: 11px;
        color: #999999;
        height: 24px;
        line-height: 24px;
      }
    }

    .twoLine {
      height: 24px;
      font-size: 11px;
      color: #999999;
      line-height: 24px;
    }
  }
}
.text-overflow {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏
}
/deep/.openDialog {
  .el-dialog__body {
    padding-top: 0;
  }
  .openTitle {
    height: 28px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
  }
  .openText {
    height: 24px;
    font-size: 16px;
    color: #999999;
    line-height: 24px;
  }

  .openBtnLine {
    margin-top: 30px;
    display: flex;
    align-items: center;

    button {
      width: 175px;
      height: 36px;
      background: #f8fafc;
      border-radius: 18px;
      color: #666666;
      cursor: pointer;

      &.active {
        color: #fff;
        background: #478aff;
      }

      &:last-of-type {
        margin-left: 24px;
      }
    }
  }
}

.selectLocationBox {
  .el-table {
    border: 1px solid #e8e8e8;

    .el-table thead {
      background-color: #f8fafc;
      color: rgba(0, 0, 0, 0.85);
    }

    .selectText {
      height: 21px;
      font-size: 14px;
      color: #478aff;
      line-height: 21px;
      cursor: pointer;
    }
  }
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  width: 10px;
  height: 10px;
  background-color: #478aff;
}

/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background: unset;
  border-color: #409eff;
}

/deep/.all-cabinet {
  .el-radio {
    display: flex;
    align-items: center;
  }

  .el-radio__input {
    display: flex;
    align-items: center;
  }

  .el-radio__label {
    display: flex;
    align-items: center;
  }
}
.search-btn {
  width: 151px;
  margin-left: 32px;
  height: 54px;
  background: #478aff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 22px;
}
.codeBox{
  margin-top:10px;
  margin-left:10px;
}

.printCabContent{
  width: 85px;
  font-size: 15px;
}
.printCabTitle{
  font-size: 10px;
}
</style>

<style lang="less" scoped>
.el-notification.right {
  //border-left: 5px solid #00ca00;
  width: 478px;
  height: 136px;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  //background: url('../../assets/images/successBor.png') no-repeat 39px center;
  background-color: #ffffff;
  box-sizing: border-box;
  background-size: 64px;
  .el-notification__title {
    padding: 26px 0px 0 109px;
    color: #333333;
    font-size: 18px;
  }
  .el-notification__content p {
    padding-left: 109px;
    color: #999999;
    font-size: 16px;
  }
}

.success_notify{
  border-left: 5px solid #00ca00;
  background: url('../../assets/images/successBor.png') no-repeat 39px center;
}
.error_notify{
  border-left: 5px solid red;
  background: url('../../assets/images/errorBox.png') no-repeat 39px center;
}

.el-popover {
  text-align: center;
  color: #333333;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 0;
}
.el-popover__title {
  font-size: 14px;
  font-weight: normal;
}

.batchCabClass .el-dialog__body ul li:first-child {
  margin-top: 5px !important;
}
.batchCabClass .el-dialog__body{
  ul {
    li {
      margin-top: 0px !important;
      height: 27px !important;
      width: 320px;
    }
  }

}


</style>
